import { useState } from "react";

const initialState = { name: "", email: "", message: "" };
const FORM_ENDPOINT = "https://formsubmit.co/ajax/info@netrabharat.com";

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState({ sending: false, sent: false, error: false });

  const handleChange = (e) => setState((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ sending: true, sent: false, error: false });
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ name, email, message, _subject: "New enquiry — netrabharat.com" }),
      });
      if (!res.ok) throw new Error();
      setStatus({ sending: false, sent: true, error: false });
      setState(initialState);
    } catch { setStatus({ sending: false, sent: false, error: true }); }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title text-center">
            <h2>Get In Touch</h2>
            <p>Product enquiries, bulk orders, partnership proposals, export enquiries — we respond within 24 business hours.</p>
          </div>
          <div className="row">
            <div className="col-md-7">
              <form onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="c-name">Your Name</label>
                      <input id="c-name" type="text" name="name" className="form-control" placeholder="Your full name" required value={name} onChange={handleChange} aria-required="true" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="c-email">Email Address</label>
                      <input id="c-email" type="email" name="email" className="form-control" placeholder="you@company.com" required value={email} onChange={handleChange} aria-required="true" />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="c-message">Message</label>
                  <textarea id="c-message" name="message" className="form-control" rows="5" placeholder="Product enquiry, bulk order, OEM query, export enquiry..." required value={message} onChange={handleChange} aria-required="true"></textarea>
                </div>
                {status.sent  && <div className="alert alert-success" role="alert"><i className="fa fa-check-circle"></i> Message sent! We'll get back to you within 24 business hours.</div>}
                {status.error && <div className="alert alert-danger"  role="alert"><i className="fa fa-exclamation-circle"></i> Something went wrong. Please WhatsApp us directly.</div>}
                <button type="submit" className="btn btn-custom" disabled={status.sending}>
                  {status.sending ? <span><i className="fa fa-spinner fa-spin"></i> Sending...</span> : "Send Message"}
                </button>
              </form>
            </div>
            <div className="col-md-4 col-md-offset-1">
              <div className="contact-info-block">
                <h3>Contact Details</h3>
                <div className="contact-item">
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <div><strong>Address</strong><p>{props.data ? props.data.address : ""}</p></div>
                </div>
                <div className="contact-item">
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  <div><strong>Phone</strong><p><a href={`tel:${props.data?.phone}`}>{props.data?.phone}</a></p></div>
                </div>
                <div className="contact-item">
                  <i className="fa fa-envelope-o" aria-hidden="true"></i>
                  <div><strong>Email</strong><p><a href={`mailto:${props.data?.email}`}>{props.data?.email}</a></p></div>
                </div>
                <div className="contact-item">
                  <i className="fa fa-globe" aria-hidden="true"></i>
                  <div><strong>Export Enquiries</strong><p>We supply to Nepal and international markets. Mention your country in the message.</p></div>
                </div>
                <div className="contact-item">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                  <div><strong>Business Hours</strong><p>Mon – Sat: 10:00 AM – 6:00 PM IST</p><p className="contact-closed">Sunday & Public Holidays: Closed</p></div>
                </div>
                <a href={props.data?.whatsapp || "https://wa.me/911141681813"} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
                  <i className="fa fa-whatsapp" aria-hidden="true"></i> Chat on WhatsApp
                </a>
                <p className="contact-response-note"><i className="fa fa-bolt" aria-hidden="true"></i> Most enquiries answered within 24 business hours.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer id="footer" role="contentinfo">
        <div className="container">
          <div className="row footer-top">
            <div className="col-md-4 footer-col">
              <img src="https://res.cloudinary.com/dbgzzcwvr/image/upload/v1756632676/icon_xqzodb.png" alt="Netra Bharat Industries" className="footer-logo" />
              <h4>Netra Bharat Industries Pvt. Ltd.</h4>
              <p>A growing consumer products company focused on cookware, kitchenware, household products, product sourcing, quality assurance, distribution and brand development. Our mission is to build trusted products and strong brands while continuously expanding into new categories and markets.</p>
              <a href="https://wa.me/911141681813" target="_blank" rel="noopener noreferrer" className="footer-whatsapp">
                <i className="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp Us
              </a>
            </div>
            <div className="col-md-2 col-sm-4 footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">What We Do</a></li>
                <li><a href="#products">Products</a></li>
                <li><a href="#certifications">Quality & Compliance</a></li>
                <li><a href="#brands">Our Brands</a></li>
                <li><a href="#portfolio">Gallery</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="col-md-3 col-sm-4 footer-col">
              <h4>For Business</h4>
              <ul>
                <li><a href="#distributor">Become a Partner</a></li>
                <li><a href="#distributor">Export Enquiries</a></li>
                <li><a href="#services">OEM & Bulk Supply</a></li>
                <li><a href="#certifications">Certifications</a></li>
                <li><a href="/PDF/Utensy_Product_Catalogue_2026.pdf" target="_blank" rel="noopener noreferrer">Download Catalogue</a></li>
              </ul>
            </div>
            <div className="col-md-3 col-sm-4 footer-col">
              <h4>Address</h4>
              <p>79, Pocket L, DSIIDC Industrial Area,<br />Sector 1, Bawana,<br />New Delhi – 110039, India</p>
              <p><i className="fa fa-phone" aria-hidden="true"></i> +91 1141681813</p>
              <p><i className="fa fa-envelope-o" aria-hidden="true"></i> info@netrabharat.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} Netra Bharat Industries Pvt. Ltd. | All Rights Reserved</p>
            <p className="footer-keywords">Kitchenware Manufacturer India · Pressure Cooker Supplier · Tri-Ply Cookware · OEM Kitchenware · Gas Stove Supplier · Consumer Products Company India · Kitchenware Exporter · Nepal Kitchenware Supplier</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
